import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
// VeeValidateを追加
import { extend, ValidationProvider, ValidationObserver,setInteractionMode } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { required, max, numeric } from "vee-validate/dist/rules";
import ja from 'vee-validate/dist/locale/ja'
import VModal from 'vue-js-modal'
import ConstList from './ConstList'
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// 共通CSSのインポート
import './assets/common.css';

// ダイアログの設定
Vue.use(VuejsDialog);

Vue.config.devtools = true;
Vue.config.performance = true
Vue.use(CoreuiVue)
// VeeValidateの設定
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: ja.messages[rule] // add its message（メッセージの日本語化）
  });
}
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
setInteractionMode('eager');

extend("required", {
  ...required,
  message: ConstList.REQUIRED
});

extend("numeric", {
  ...numeric,
  message: ConstList.NUMERIC
});

extend("max", {
  ...max,
  message: ConstList.MAX
});

// メールアドレスのカスタムルール
const email =  {
  message: ConstList.EMAIL_ERROR,
  validate(value) {
    if (value.match(ConstList.EMAIL_REGEX)) {
      return true
    }
  }
}
extend('email', email)

// 勤務表の時間のカスタムルール
const time = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.TIME_REGEX)) {
      return true
    }
  }
}
extend('time', time)

// 有給と代休のカスタムルール
const holiday = {
  message: ConstList.HOLIDAY_ERROR,
  validate(value) {
    if (value.match(ConstList.HOLIDAY_REGEX) || value.match(ConstList.DECIMAL_REGEX)) {
      return true
    }
  }
}
extend('holiday', holiday)

// 業務報告書の月日のカスタムルール
const date = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.DATE_REGEX)) {
      return true
    }
  }
}
extend('date', date)

// 業務報告書の基準時間のカスタムルール
const base_time = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.BASE_TIME_REGEX)) {
      return true
    }
  }
}
extend('base_time', base_time)

// 業務報告書の勤務時間時間時間時間等のカスタムルール
const total_time = {
  message: ConstList.NUM_SYMBOL,
  validate(value) {
    if (value.match(ConstList.WORK_TIME_REGEX)) {
      return true
    }
  }
}
extend('total_time', total_time)

// 社員番号のカスタムルール
const employee = {
  message: ConstList.EMPLOYEE_ERROR,
  validate(value) {
    if (value.match(ConstList.FULL_NUM_REGEX)) {
      return true
    }
  }
}
extend('employee', employee)

// 氏名のカスタムルール
const name = {
  params: ['num'],
  message: ConstList.FULL_WIDTH,
  validate(value, {num}) {
    if (value.length > num) {
      return false
    }
    if (value.match(ConstList.FULL_WIDTH_REGEX)) {
      return false
    }
    if (value.match(ConstList.HALF_KATAKANA_REGEX)) {
      return false
    }
    if (value.match(ConstList.USER_NAME_PATTEN_REGEX)) {
      return true
    }
  }
}
extend('name', name)

// 住所の文字種制限
const address = {
  message: ConstList.ADDRESS_ERROR,
  validate(value) {
    if (value.match(ConstList.HALF_KATAKANA_REGEX)) {
      return false
    }
    if (value.match(ConstList.FULL_WIDTH_REGEX)) {
      return false
    }
    return true
  }
}
extend('address', address)

// 電話番号のカスタムルール
const telephone = {
  message: ConstList.TELEPHONE_ERROR,
  validate(value) {
    if (value.length < 10 || value.length > 16) {
      return false
    }
    if(value.match(ConstList.TELEPHONE_REGEX)) {
      return true
    }
  }
}
extend('tel', telephone)

// 同値チェックのカスタムルール
const check = {
  params: [{
    name: 'str',
    isTarget: true
  }],
  message: ConstList.SAME,
  validate(value, {str}) {
    return value == str;
  }
};
extend('check', check);

// 半角英数字混在（記号の有無は問わない）
const password = {
  message: ConstList.PASSWORD_ERROR,
  validate(value) {
    if (value.match(ConstList.PASSWORD_REGEX)) {
      return true
    }
  }
}
extend('password', password)

// 選択必須のカスタムルール
const select = {
  ...required,
  message: ConstList.SELECT
}
extend('select', select)

// 年月のカスタムルール
const month_year = {
  message: '{_field_}はYYYYMM形式で入力してください。',
  validate(value) {
    if (value.length == 6) {
      return true
    }else{
      return false
    }
  }
}
extend('month_year', month_year)

// 年月のカスタムルール
const month_math = {
  message: '{_field_}は半角数字で入力してください。',
  validate(value) {
    if (value.match(/\d/)) {
      return true
    }
  }
}
extend('month_math', month_math)

// 予定時間外申請の時間入力のカスタムルール(半角数字or小数点以下制限)
const half_width_and_limit_decimal = {
  message: ConstList.HALF_WIDTH_LIMIT_DECIMAL2_ERROR,
  validate(value) {
    if (value.match(ConstList.HALF_WIDTH_DECIMAL_REGEX2)) {
      return true
    }
  }
}
extend('half_width_and_limit_decimal', half_width_and_limit_decimal)

const hourMinute = {
  message: ConstList.HOUR_MINUTE_ERROR,
  validate(value) {
    if (!value.match(ConstList.TIME_REGEX)) {
      return false
    }

    // 時・分の範囲確認
    const [hours, minutes] = value.split(':').map(Number)

    return (
      hours >= 0 && hours <= 23 &&
      minutes >= 0 && minutes <= 59
    )
  }
}

extend('hourMinute', hourMinute)


// VModalの設定
Vue.use(VModal);

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
